import { render, staticRenderFns } from "./NoticeResendDialog.vue?vue&type=template&id=ad80d8be&"
import script from "./NoticeResendDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeResendDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports